import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "translation"
    }}>{`Translation`}</h1>
    <p>{`If you're using `}<inlineCode parentName="p">{`chawkbazar-laravel`}</inlineCode>{` after `}<inlineCode parentName="p">{`v2.0.0`}</inlineCode>{` then you can translate static content for multilanguage. It doesn't matter if the language is RTL or not, you can do both. For translation we use this `}<a parentName="p" {...{
        "href": "https://github.com/isaachinman/next-i18next"
      }}>{`next-i18next`}</a>{` package.`}</p>
    <h2 {...{
      "id": "existing-language"
    }}>{`Existing Language`}</h2>
    <p>{`Right now, we provide translation files for `}<inlineCode parentName="p">{`ar`}</inlineCode>{`, `}<inlineCode parentName="p">{`de`}</inlineCode>{`, `}<inlineCode parentName="p">{`en`}</inlineCode>{`, `}<inlineCode parentName="p">{`es`}</inlineCode>{`, `}<inlineCode parentName="p">{`he`}</inlineCode>{`, and `}<inlineCode parentName="p">{`zh.`}</inlineCode></p>
    <p>{`If your translation language is from them then just edit the translation string from,`}</p>
    <h4 {...{
      "id": "for-rest"
    }}>{`For Rest`}</h4>
    <pre><code parentName="pre" {...{}}>{`chawkbazar-laravel -> shop -> public -> locales -> YOUR LANGUAGE
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`chawkbazar-laravel -> admin -> rest -> public -> locales -> YOUR LANGUAGE
`}</code></pre>
    <p><img alt="Translation.png" src={require("./images/Translation.png")} /></p>
    <p>{`After translating `}<inlineCode parentName="p">{`string`}</inlineCode>{` from `}<inlineCode parentName="p">{`JSON `}</inlineCode>{`re-run`}<inlineCode parentName="p">{`or`}</inlineCode>{`rebuild\` project it'll translate the static string.`}</p>
    <h2 {...{
      "id": "new-language"
    }}>{`New Language`}</h2>
    <p>{`If your language is not in the lists then just copy the `}<inlineCode parentName="p">{`en`}</inlineCode>{` folder from `}<inlineCode parentName="p">{`locale`}</inlineCode>{` and paste it in the same folder by rename your language code.`}</p>
    <p><img alt="NewLanguage.png" src={require("./images/NewLanguage.png")} /></p>
    <p>{`After creating that folder edit `}<inlineCode parentName="p">{`next-i18next.config.js`}</inlineCode>{` and add the `}<inlineCode parentName="p">{`language-code`}</inlineCode>{` at `}<inlineCode parentName="p">{`locales`}</inlineCode>{` object.`}</p>
    <p><img alt="RegisterLanguage.png" src={require("./images/RegisterLanguage.png")} /></p>
    <h2 {...{
      "id": "default-language"
    }}>{`Default Language`}</h2>
    <p>{`By default, English is the default language. To change that edit,`}</p>
    <pre><code parentName="pre" {...{}}>{`chawkbazar-laravel -> shop -> public -> locales -> YOUR LANGUAGE -> next-i18next.config.js
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`chawkbazar-laravel -> admin -> rest -> public -> locales -> YOUR LANGUAGE -> next-i18next.config.js
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      